<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline font-weight-light blue--text">Datos Personales</span>
        </v-card-title>
        <v-card-text v-if="datos">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field label="Nombre*" v-model="datos.nombre" @input="forceUppercase($event, datos, 'nombre')" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field label="Primer apellido*" v-model="datos.apellido1" @input="forceUppercase($event, datos, 'apellido1')" required></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field label="Segundo apellido*" v-model="datos.apellido2" @input="forceUppercase($event, datos, 'apellido2')" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <span class="blue--text body-1">Dirección:</span>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="Calle*" v-model="datos.direccion.calle" @input="forceUppercase($event, datos.direccion, 'calle')" required></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-autocomplete
                  v-model="datos.direccion.provincia"
                  :items="getProvinciasSelect"
                  :filter="customFilter"
                  item-text="text"
                  label="Provincia*"
                  @change="changeProvincia"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field label="C.P.*" v-model="datos.direccion.cp" required></v-text-field>
              </v-flex>
              <v-flex xs12 md8>
                <v-autocomplete
                  v-model="datos.direccion.localidad"
                  :items="getMunicipiosSelect"
                  :filter="customFilter"
                  item-text="text"
                  label="Localidad*"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <span class="blue--text body-1">Fecha de nacimiento:</span>
              </v-flex>
              <v-flex xs3 sm2>
                <v-autocomplete
                  v-model="datos.fechaNacimientoDia"
                  :items="fechaNac.dias"
                  label="Dia*"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs3 sm2>
                <v-autocomplete
                  v-model="datos.fechaNacimientoMes"
                  :items="fechaNac.meses"
                  label="Mes*"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 sm2>
                <v-autocomplete
                  v-model="datos.fechaNacimientoYear"
                  :items="fechaNac.years"
                  label="Año*"
                  required
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field label="NIF*" v-model="datos.nif" @input="forceUppercase($event, datos, 'nif')"></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <v-autocomplete
                  v-model="datos.sexo"
                  :items="[{text: 'Hombre', value: 1}, {text: 'Mujer', value: 2}]"
                  :filter="customFilter"
                  item-text="text"
                  label="Sexo"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <span class="blue--text body-1">Teléfono/s:</span>
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  label="Móvil Principal"
                  v-model="datos.tlf1"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm9>
                <v-combobox
                  v-model="datos.tlf"
                  :items="phoneItems"
                  :search-input.sync="phoneSearch"
                  hide-selected
                  hint="Escriba un número de teléfono y presione ENTER para introducirlo"
                  label="Otros teléfonos de contacto"
                  multiple
                  persistent-hint
                  deletable-chips
                  small-chips
                >
                </v-combobox>
              </v-flex>
              <v-flex xs12>
                <span class="blue--text body-1">Discapacidad:</span>
              </v-flex>
              <v-flex xs12>
                <!-- <v-switch
                  v-model="datos.discapacidad.isDiscapacidad"
                  :label="discapacidadLabel"
                ></v-switch> -->
                <v-switch v-model="datos.discapacidad.isDiscapacidad">
                  <template v-slot:label>
                    ¿Tiene alguna discapacidad reconocida?:&nbsp;&nbsp;<span :class="discapacidadLabel.class">{{discapacidadLabel.text}}</span>
                  </template>
                </v-switch>
              </v-flex>
              <template v-if="datos.discapacidad.isDiscapacidad">
                <v-flex xs12 sm9>
                  <v-radio-group v-model="datos.discapacidad.tipo" column>
                    <v-radio
                      label="i: cerebral, mental, intelectual"
                      color="green"
                      value="i"
                    ></v-radio>
                    <v-radio
                      label="ii: Física o sensorial"
                      color="red"
                      value="ii"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm3>
                  <v-text-field :disabled="!!!datos.discapacidad.tipo" label="Grado" v-model="datos.discapacidad.grado" prefix="%" maxlength="2" type="number" min="33" max="99"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-switch 
                  v-model="datos.discapacidad.documentoDiscapacidad"
                  label="¿Tiene un documento acreditativo de su discapacidad?"
                  >
                  </v-switch>
                </v-flex>
                <v-flex xs12>
                  <v-switch 
                  v-model="datos.discapacidad.movilidad"
                  label="¿Tiene reducida su movilidad?"
                  >
                  </v-switch>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
          <small>*Campos requeridos</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Cerrar</v-btn>
          <v-btn color="blue darken-1" flat @click="saveDataForm">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { completaNif } from "@/plugins/functions.js";
export default {
  props: ["usuario", "formName"],
  data: () => ({
    dialog: false,
    datos: null,
    phoneItems: [],
    phoneSearch: null
  }),
  watch: {
    dialogUsuario(newValue) {
      console.log("cambio por watch");
      this.dialog = newValue;
    },
    dialog(newValue) {
      if (newValue) {
        console.log("abierto diálogo. leer usuario...");
        this.datos = Object.assign(
          {},
          this.propietarioModel,
          JSON.parse(JSON.stringify(this.usuario))
        );
        if (this.datos.direccion.provincia) {
          this.setMunicipios(this.datos.direccion.provincia);
        }
      }
      this.setPropietarioDialog({
        dialog: this.formName,
        value: newValue
      });
    }
  },
  computed: {
    ...mapGetters([
      "getProvinciasSelect",
      "getMunicipiosSelect",
      "dialogUsuario",
      "propietarioModel",
      "fechaNac"
    ]),
    discapacidadLabel() {
      let result = {class:'red--text',text: ' - No -'};// 'Ninguna discapacidad reconocida';
      if (this.datos && this.datos.discapacidad.isDiscapacidad) {
        result = {class:'green--text',text: ' - Si -'}; // 'Padezco alguna discapacidad reconocida'
      };
      // result = `¿Tiene reconocida alguna discapacidad? ${result}`;
      return result;
    }
  },
  methods: {
    ...mapActions(["saveDataUser", "setMunicipios", "setPropietarioDialog"]),
    customFilter(item, queryText) {
      const textOne = item.text.toLowerCase();
      const searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1;
    },
    changeProvincia() {
      this.setMunicipios(this.datos.direccion.provincia);
      this.datos.direccion.localidad = null;
    },
    forceUppercase(e, o, prop) {
      // this.aaa = e
      if (prop === "nif" && o.nif.length === 8) {
        this.$set(o, prop, completaNif(o.nif));
        return;
      }
      //https://forum.vuejs.org/t/inputs-always-in-uppercase-using-v-model/7450/9
      e = e.toUpperCase();
      this.$set(o, prop, e);
    },
    saveDataForm() {
      this.saveDataUser(this.datos);
      this.dialog = false;
    }
  }
};
</script>
